import { useIntl } from "react-intl";
import { DetailsField } from "components/DetailsField";
import { HistoryDetailsPaymentsWithholdingProps } from "./types";
import { messages } from "./messages";
import { useFormatter } from "hooks/utils/useFormatter";
import { HistoryDownloadReceipt } from "../HistoryDownloadReceipt";
import { RECEIPT_TYPE } from "../HistoryDownloadReceipt/types";

export const HistoryDetailsPaymentsWithholding: React.FC<
  HistoryDetailsPaymentsWithholdingProps
> = ({ data: withhold }) => {
  const { formatMessage } = useIntl();
  const { formatValue } = useFormatter();

  const getStatus = (state?: string) => {
    let stClass = "text-[--color-warning]";
    let st = formatMessage(messages.statusInProgress);

    switch (state) {
      case "succeed":
        stClass = "text-[--color-success]";
        st = formatMessage(messages.approved);
        break;
      case "failed":
        stClass = "text-[--color-error]";
        st = formatMessage(messages.rejected);
        break;
    }
    return <span className={stClass}>{st}</span>;
  };
  return (
    <div className="flex flex-col gap-y-6 pdf:p-10">
      <DetailsField
        label={formatMessage(messages.retainedWithholding)}
        value={`${formatValue(
          withhold.amount,
          withhold.precision,
        )} ${withhold.ticker_id.toUpperCase()}`}
      />
      <DetailsField
        label={formatMessage(messages.baseWithholding)}
        value={`${formatValue(
          withhold.extra_data.base_amount || "",
          withhold.precision,
        )} ${withhold.ticker_id.toUpperCase()}`}
      />
      <DetailsField
        label={formatMessage(messages.aliWithholding)}
        value={`${withhold.extra_data.tax?.amount || ""} %`}
      />
      <DetailsField
        label={formatMessage(messages.description)}
        value={withhold.extra_data.tax?.description ?? ""}
      />
      <DetailsField
        className="pdf:hidden"
        label={formatMessage(messages.status)}
        value={getStatus(withhold.extra_data.state)}
      />
      <DetailsField
        label={formatMessage(messages.movementId)}
        value={withhold.tid ?? ""}
        copy
      />
      <HistoryDownloadReceipt
        receiptType={RECEIPT_TYPE.WITHHOLDING}
        movement={withhold}
      />
    </div>
  );
};
